(function ($) {

'use strict';

	/**
	 * i81n text translation.
	 * This object is used to translate text placeholders to users language.
	 * Language code detection is done on the php backend.
	 */
	$.i81n = {
		// status of initialisation 
		initDone: false,
		// error status 
		error: false,
		// langData member gets initialized with an object containing the texts
		langData: null,
		// do an ajax call to load and initialize langData
		init: function () {
			var myThis = this;
			// Return the jqXHR object so we can chain callbacks
			return $.ajax({
				type: 'POST',
				cache: true,
				url: '/index.php',
				//async: false,
				data: 'gld=1&x=' + window.screen.availWidth + '&y=' + window.screen.availHeight,
				success: function (data) {
					myThis.langData = $.extend(this.langData, JSON.parse(data));
					myThis.initDone = true;
					//console.log('langData loaded! ',myThis.langData);
				},
				error: function (jqXHR, textStatus, errorThrown) {
					console.log('Error get lang data! ' + textStatus);
					myThis.initDone = true;
					myThis.error = true;
				}

			});
		},
		/**
		 * call text('PLACEHOLDERNAME) to get the translated text
		 * @param {string} name constant
		 * @returns {initCommon.common_L13.$.i81n.langData|String}
		 */
		text: function (name) {
			if (!this.langData || typeof this.langData[name] !== 'string') {
				var msg = '-invalid placeholder: ' + name;
				console.log(msg);
				return msg;
			} else {
				return this.langData[name];
			}
		},
		/**
		 * call text('PLACEHOLDERNAME) to get the translated text
		 * @param {array} name constants
		 * @returns {object}
		 */
		texts: function (names) {
			var texts = {};
			for (var i = 0; i < names.length; i++) {
				if (!this.langData || typeof this.langData[names[i]] !== 'string') {
					var msg = '-invalid placeholder: ' + names[i];
					console.log(msg);
					texts[names[i]] = msg;
				} else {
					texts[names[i]] = this.langData[names[i]];
				}
			}
			return texts;
		},
	};

}(jQuery));